// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav-module--nav--L7246","logo":"nav-module--logo--2MrbU","right":"nav-module--right--GCPHT","menuItem":"nav-module--menuItem--29NiE","dropdown":"nav-module--dropdown--3rQDL"};